import script from "./Consent.vue?vue&type=script&setup=true&lang=ts"
export * from "./Consent.vue?vue&type=script&setup=true&lang=ts"

import "./Consent.vue?vue&type=style&index=0&id=ae82feda&lang=css"

const __exports__ = script;

export default __exports__